/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Rights_Item_Access_DescInputs */

const en_privacy_rights_item_access_desc = /** @type {(inputs: Privacy_Rights_Item_Access_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` (Art. 15) — Obtain a copy of your personal data`)
};

const de_privacy_rights_item_access_desc = /** @type {(inputs: Privacy_Rights_Item_Access_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` (Art. 15) -- Erhalten Sie eine Kopie Ihrer personenbezogenen Daten`)
};

const fr_privacy_rights_item_access_desc = /** @type {(inputs: Privacy_Rights_Item_Access_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` (Art. 15) -- Obtenir une copie de vos données personnelles`)
};

const es_privacy_rights_item_access_desc = /** @type {(inputs: Privacy_Rights_Item_Access_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` (Art. 15) -- Obtener una copia de sus datos personales`)
};

const it_privacy_rights_item_access_desc = /** @type {(inputs: Privacy_Rights_Item_Access_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` (Art. 15) — Ottenere una copia dei tuoi dati personali`)
};

const nl_privacy_rights_item_access_desc = /** @type {(inputs: Privacy_Rights_Item_Access_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` (Art. 15) — Een kopie van uw persoonlijke gegevens verkrijgen`)
};

const pl_privacy_rights_item_access_desc = /** @type {(inputs: Privacy_Rights_Item_Access_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` (Art. 15) — Uzyskanie kopii swoich danych osobowych`)
};

const fi_privacy_rights_item_access_desc = /** @type {(inputs: Privacy_Rights_Item_Access_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` (artikla 15) — Saa kopio henkilötiedoistasi`)
};

const da_privacy_rights_item_access_desc = /** @type {(inputs: Privacy_Rights_Item_Access_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` (Art. 15) — Få en kopi af dine persondata`)
};

const sv_privacy_rights_item_access_desc = /** @type {(inputs: Privacy_Rights_Item_Access_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` (Art. 15) — Få en kopia av dina personuppgifter`)
};

/**
* | output |
* | --- |
* | "(Art. 15) — Obtain a copy of your personal data" |
*
* @param {Privacy_Rights_Item_Access_DescInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const privacy_rights_item_access_desc = /** @type {((inputs?: Privacy_Rights_Item_Access_DescInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Rights_Item_Access_DescInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_privacy_rights_item_access_desc(inputs)
	if (locale === "fr") return fr_privacy_rights_item_access_desc(inputs)
	if (locale === "es") return es_privacy_rights_item_access_desc(inputs)
	if (locale === "it") return it_privacy_rights_item_access_desc(inputs)
	if (locale === "nl") return nl_privacy_rights_item_access_desc(inputs)
	if (locale === "pl") return pl_privacy_rights_item_access_desc(inputs)
	if (locale === "fi") return fi_privacy_rights_item_access_desc(inputs)
	if (locale === "da") return da_privacy_rights_item_access_desc(inputs)
	if (locale === "sv") return sv_privacy_rights_item_access_desc(inputs)
	return en_privacy_rights_item_access_desc(inputs)
});